<template>
    <table>
        <thead>
            <tr>
                <th colspan="2"></th>
                <th colspan="2" style="padding: 0 !important"></th>

            </tr>
        </thead>
        <tbody>
            <pup-item
                v-on="$listeners"
                :pup="pup"
                :key="pup.pargoPointCode"
                v-for="pup in closestPups"
            ></pup-item>
        </tbody>
    </table>
</template>

<script>
import PuPItem from "./PuPItem.vue";
export default {
    props: ["closestPups"],
    components: { "pup-item": PuPItem },
    mounted() {
    },
};
</script>

<style></style>
